import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const Complain = () => {
  const [essays, setEssays] = useState([]);
  const [selectedEssay, setSelectedEssay] = useState('');
  const [complain, setComplain] = useState('');

  // Fetch essays for the corresponding user
  useEffect(() => {
    const fetchEssays = async () => {
      try {
        const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getUploadedEssays?Id=${Cookies.get('id')}`);
        setEssays(response.data.essays); // Assuming the API returns an array of essays in `response.data.essays`
      } catch (error) {
        console.error('Error fetching essays:', error);
        alert('Failed to fetch essays. Please check the server logs.');
      }
    };

    fetchEssays();
  }, []);

 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const studentId = Cookies.get('id');
    const essayId = selectedEssay;
    const complainDetails = complain;

    const data = {
      studentId,
      essayId,
      complainDetails
    };

    console.log(data);

    try {
      const response = await axios.post('https://backend.writerswright.com/api/v1/student/addcomplain', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(response.data); // Log response for debugging
      alert('Complain submitted successfully.');
      // Optionally clear the form or update state
      setSelectedEssay('');
      setComplain('');
    } catch (error) {
      console.error('Error submitting complain:', error);
      alert('Failed to submit complain. Please check the server logs.');
    }
  };


  return (
    <>
      <h2 className="mb-4 title" style={{ textAlign: 'left' }}>Complain</h2>
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ background: '#f8f9fa' }}>
        <div style={{ maxWidth: '800px', width: '100%', padding: '20px', border: '1px solid #ccc', borderRadius: '10px', backgroundColor: 'white', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="essay" className="form-label text">Choose Corresponding Essay</label>
                <select
                  className="form-select"
                  id="essay"
                  name="essay"
                  value={selectedEssay}
                  onChange={(e) => setSelectedEssay(e.target.value)}
                  required
                >
                  <option value="">Select Essay...</option>
                  {essays.map((essay) => (
                    <option key={essay.Id} value={essay.Id}>
                      {essay.Title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="complain" className="form-label text">Complain</label>
              <textarea
                className="form-control"
                id="complain"
                name="complain"
                rows="4"
                value={complain}
                onChange={(e) => setComplain(e.target.value)}
                required
              />
            </div>
            <button className="button-37" role="button" style={{ width: '100%', marginTop: '9px' }}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Complain;
